<template>
  <b-sidebar
    id="sidebar"
    shadow
    no-header
    :visible="isVisible"
    z-index="99"
    no-close-on-route-change
    :right="isMobile"
    :backdrop="isMobile"
    class="sidebar"
  >
    <nav class="mt-3 mt-md-0 pt-5 p-md-0">
      <ul class="nav flex-column pt-2">
        <li class="nav-item">
          <router-link
            :to="{ name: '廠商帳號管理' }"
            v-slot="{ href, isActive }"
          >
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >廠商帳號管理</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: '會員列表' }" v-slot="{ href, isActive }">
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >會員列表</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <a
            v-b-toggle.nav-item-collapse
            variant="link"
            class="py-3 nav-link d-flex justify-content-between align-items-center"
            :class="{ active: navItemChildShow }"
            href="javascript:;"
          >
            <span>分類管理</span>
            <b-icon-chevron-down v-if="navItemChildShow"></b-icon-chevron-down>
            <b-icon-chevron-right v-else></b-icon-chevron-right>
          </a>
          <b-collapse
            id="nav-item-collapse"
            class="nav-item-child"
            :visible="navItemChildShow"
            @show="OnNavItemChildShow"
            @hide="OnNavItemChildHide"
          >
            <ul class="nav flex-column">
              <li class="nav-item">
                <router-link
                  :to="{ name: '汽車品牌' }"
                  v-slot="{ href, isActive }"
                >
                  <a
                    class="nav-link py-3 pl-4"
                    :class="{ active: isActive }"
                    :href="href"
                    >汽車品牌</a
                  >
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: '零件品牌' }"
                  v-slot="{ href, isActive }"
                >
                  <a
                    class="nav-link py-3  pl-4"
                    :class="{ active: isActive }"
                    :href="href"
                    >零件品牌</a
                  >
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: '零件分類' }"
                  v-slot="{ href, isActive }"
                >
                  <a
                    class="nav-link py-3  pl-4"
                    :class="{ active: isActive }"
                    :href="href"
                    >零件分類</a
                  >
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: '購物須知' }" v-slot="{ href, isActive }">
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >購物須知頁</a
            >
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link :to="{ name: '報表' }" v-slot="{ href, isActive }">
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >報表</a
            >
          </router-link>
        </li> -->
        <li class="nav-item">
          <b-button v-b-modal.modal-SMS class="nav-link p-3" variant="link"
            >簡訊王點數查詢</b-button
          >
        </li>
      </ul>
    </nav>
    <b-modal
      id="modal-SMS"
      size="sm"
      title="簡訊王點數"
      hide-footer
      body-class="text-center"
      @show="SMSModal"
    >
      <div>
        剩餘<span class="px-2 h4 text-manage_main">{{ sms_point }}</span
        >點
      </div>
    </b-modal>
  </b-sidebar>
</template>

<style lang="scss" scoped>
.sidebar ::v-deep .b-sidebar {
  background-color: #eaedf4 !important;
  .nav-link {
    &.active {
      color: $manage_main;
    }
  }
}
.nav-item-child {
  background-color: #dadfea;
  .nav-link.active {
    background-color: #dadfea;
    &::after {
      background-color: $manage_main;
    }
  }
}
</style>

<script>
import { SMS } from "@/assets/api/manage.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "Sidebar",
  props: ["isMobile", "token"],
  data() {
    return {
      isVisible: true,
      navItemChildShow: false,
      sms_point: 0
    };
  },
  watch: {
    isMobile(data) {
      if (data) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    }
  },
  methods: {
    SMSModal() {
      SMS.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.sms_point = res.data.point;
          } else {
            Toast.fire({
              icon: "error",
              title: "簡訊王資訊取得失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    hasClass(ele, cls) {
      return (" " + ele.className + " ").indexOf(" " + cls + " ") > -1;
    },
    OnNavItemChildShow() {
      this.navItemChildShow = true;
    },
    OnNavItemChildHide() {
      this.navItemChildShow = false;
    }
  },
  mounted() {
    const vm = this;
    if (vm.isMobile) {
      vm.isVisible = false;
    } else {
      vm.isVisible = true;
    }
    const navItemChilds = document.querySelectorAll(
      ".nav-item-child .nav-link"
    );
    [].forEach.call(navItemChilds, ele => {
      if (vm.hasClass(ele, "active")) {
        vm.navItemChildShow = true;
        // vm.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
        //   console.log(collapseId, isJustShown);
        //   if (collapseId == "nav-item-collapse" && !isJustShown) {
        //     vm.navItemChildShow = true;
        //   }
        // });
      }
    });
  }
};
</script>
